import { useCallback } from 'react';
import { parseAsStringEnum, useQueryStates } from 'nuqs';
import { ScannerID } from 'types';
import { ProductType } from 'types';
import useAuth from 'hooks/auth/useAuth';

const SCANNER_QUERY_KEYS = {
  scanner: parseAsStringEnum<ScannerID>(Object.values(ScannerID)),
};

export function useScannerUrlState(prefix?: string) {
  const { hasAccessToProduct } = useAuth();
  const hasScannersAccess = hasAccessToProduct(ProductType.SCANNERS);

  const [params, setParams] = useQueryStates(
    SCANNER_QUERY_KEYS,
    prefix != null
      ? {
          urlKeys: {
            scanner: `${prefix}_scanner`,
          },
        }
      : undefined,
  );

  const activeScanner = params.scanner ?? undefined;

  const setActiveScanner = useCallback(
    (scanner: ScannerID | undefined) => {
      if (!hasScannersAccess || scanner == null) {
        void setParams({ scanner: null });
      } else {
        void setParams({ scanner });
      }
    },
    [hasScannersAccess, setParams],
  );

  return {
    activeScanner,
    setActiveScanner,
  };
}
